import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { LOGO_URL } from "../lib/kk";

const scrollLinks = [
  { label: "About", id: "about", type: "scroll" },
  { label: "Puppies", id: "puppies", type: "scroll" },
  { label: "Puppy Waitlist", to: "/puppy-waitlist", type: "page" },
  { label: "Health", id: "health", type: "scroll" },
  { label: "FAQ", id: "faq", type: "scroll" },
  { label: "Contact Us", id: "contact", type: "scroll" },
];

const pageLinks = [
  { label: "Stud Service", to: "/stud-service" },
  { label: "Productions", to: "/productions" },
  { label: "Owner Updates", to: "/owner-updates" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const goToSection = (id) => {
    setOpen(false);
    if (location.pathname !== "/") {
      navigate("/", { state: { scrollTo: id } });
    } else {
      document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <nav
      className="sticky top-0 z-50 bg-[#111111]/95 backdrop-blur-md border-b-[3px] border-b-[#BB0000]"
      data-testid="navbar"
    >
      <div className="max-w-7xl mx-auto px-5 md:px-10 h-16 flex items-center justify-between">
        <div className="hidden lg:flex items-center gap-6">
          {scrollLinks.map((l) =>
            l.type === "page" ? (
              <Link
                key={l.to}
                to={l.to}
                data-testid={`nav-page-${l.to.replace("/", "")}`}
                className="font-display uppercase text-[11px] font-bold tracking-[0.14em] text-[#BB0000] hover:text-[#8B0000] transition-colors"
              >
                {l.label}
              </Link>
            ) : (
              <button
                key={l.id}
                onClick={() => goToSection(l.id)}
                data-testid={`nav-scroll-${l.id}`}
                className="font-display uppercase text-[11px] font-bold tracking-[0.14em] text-white hover:text-[#BB0000] transition-colors"
              >
                {l.label}
              </button>
            )
          )}
        </div>

        <Link to="/" className="lg:absolute lg:left-1/2 lg:-translate-x-1/2" data-testid="nav-logo">
          <img src={LOGO_URL} alt="Kallie's Kennel" className="h-14 w-auto object-contain" />
        </Link>

        <div className="hidden lg:flex items-center gap-6">
          {pageLinks.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              data-testid={`nav-page-${l.to.replace("/", "")}`}
              className="font-display uppercase text-[11px] font-bold tracking-[0.14em] text-[#A8A9AD] hover:text-[#BB0000] transition-colors"
            >
              {l.label}
            </Link>
          ))}
        </div>

        <button
          className="lg:hidden text-white ml-auto"
          onClick={() => setOpen(!open)}
          data-testid="nav-hamburger"
          aria-label="Toggle menu"
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden bg-[#111111] border-t border-[#BB0000]/40 px-6 py-6 flex flex-col gap-4" data-testid="mobile-menu">
          {scrollLinks.map((l) =>
            l.type === "page" ? (
              <Link
                key={l.to}
                to={l.to}
                onClick={() => setOpen(false)}
                className="font-display uppercase text-sm font-bold tracking-[0.14em] text-[#BB0000] text-left"
              >
                {l.label}
              </Link>
            ) : (
              <button
                key={l.id}
                onClick={() => goToSection(l.id)}
                className="font-display uppercase text-sm font-bold tracking-[0.14em] text-white text-left"
              >
                {l.label}
              </button>
            )
          )}
          <div className="h-px bg-white/10 my-1" />
          {pageLinks.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              onClick={() => setOpen(false)}
              className="font-display uppercase text-sm font-bold tracking-[0.14em] text-[#A8A9AD]"
            >
              {l.label}
            </Link>
          ))}
        </div>
      )}
    </nav>
  );
};

export default Navbar;
